import { render, staticRenderFns } from "./set-new-password.vue?vue&type=template&id=d6082d7c&"
import script from "./set-new-password.vue?vue&type=script&lang=js&"
export * from "./set-new-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports